import { StandardEventProperties } from '@betterment/js-runtime';
import { Banner, Text } from '@betterment/samba-react';

import { type BannerStyle, messageBannerVariant } from './data';
import MessageCta from './message-cta';

import { Message } from '../../../graphql/schema';

interface MessageBoxBannerProps {
  message: Message;
  handleCloseMessage: (event: React.MouseEvent<HTMLButtonElement>) => void;
  eventProperties?: StandardEventProperties;
}

const MessageBanner: React.FC<MessageBoxBannerProps> = ({ message, handleCloseMessage, eventProperties }) => {
  const variant = messageBannerVariant[message.style as BannerStyle];
  return (
    <Banner variant={variant}>
      <Banner.Content>
        <Text as="p" color="text">
          <Text dangerouslySetInnerHTML={{ __html: message.body }} />
          {message.cta && <MessageCta cta={message.cta} eventProperties={eventProperties} />}
        </Text>
      </Banner.Content>
      {message.isDismissible && <Banner.Close onClick={handleCloseMessage} />}
    </Banner>
  );
};

export default MessageBanner;
